import { clearCustomer } from "@/redux/ducks/customer";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const MENU_ITEM_CLASS =
  "text-white text-[22px] font-bold font-secondary leading-[28.8px] tracking-[-0.2px] text-left";

const MENU_ITEMS = [
  { label: "Dados pessoais", path: "/mydata" },
  { label: "Recibos", path: "/ticket" },
  { label: "Carros", path: "/myvehicles" },
  { label: "Cartões", path: "/mycards" },
  { label: "Alterar senha", path: "/password" },
  { label: "Onde usar", path: "/faq" },
  { label: "Perguntas frequentes", path: "/faq" },
];

const LoggedMenu = ({
  isShowingMenu,
  toggleMenu,
}: {
  isShowingMenu: boolean;
  toggleMenu: () => void;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isShowingMenu) {
      document.body.style.overflow = "hidden";
      return () => { document.body.style.overflow = ""; };
    }
  }, [isShowingMenu]);

  const handleMenuClick = (path: string) => {
    toggleMenu();
    navigate(path);
  };

  const logout = () => {
    dispatch(clearCustomer());
    window.location.replace('/');
  };

  if (!isShowingMenu) return null;

  return (
    <div className="fixed inset-0 top-[75px] z-[1000] bg-brand-dark flex flex-col">
      <nav className="flex-1 flex flex-col px-8 pt-12 overflow-y-auto">
        <p className="font-secondary font-light text-sm text-white tracking-[7px] leading-[18.2px] mb-12">
          O que está procurando?
        </p>

        <ul className="flex flex-col gap-[35px]">
          {MENU_ITEMS.map((item) => (
            <li key={item.label}>
              <button
                onClick={() => handleMenuClick(item.path)}
                className={MENU_ITEM_CLASS}
              >
                {item.label}
              </button>
            </li>
          ))}
          <li className="mt-4 pt-4 border-t border-white/10">
            <button onClick={logout} className={MENU_ITEM_CLASS}>
              Sair
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default LoggedMenu;
